import { Box, Button, Dialog, Stack, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import type { FC } from 'react';
import type { ModalProps } from '../../../types/shared';

interface IProps extends ModalProps {
  action: () => void;
}

const SwitchTimetableModal: FC<IProps> = ({ isOpen, close, action }) => {
  return (
    <Dialog onClose={close} open={isOpen} disableRestoreFocus>
      <Box sx={{ p: 4, width: 500 }}>
        <Box>
          <Typography variant="h4" sx={{ fontWeight: 'bold', textAlign: 'center', mb: 4 }}>
            Switching timetable type will reset existing timetable
          </Typography>
        </Box>
        <Typography variant="body1" sx={(t) => ({ color: t.palette.text.secondary, textAlign: 'center' })}>
          Rule can have only 1 timetable type at the time: Schedule (days and time) or Interval (hours and minutes).
        </Typography>
        <Box sx={{ mt: 4, display: 'flex', height: '40px' }}>
          <Button sx={{ textTransform: 'uppercase' }} size="large" onClick={close} color="primary" fullWidth>
            Cancel
          </Button>
          <LoadingButton
            size="large"
            variant="contained"
            sx={{ textTransform: 'uppercase' }}
            onClick={action}
            fullWidth
          >
            Set a new timetable
          </LoadingButton>
        </Box>
      </Box>
    </Dialog>
  );
};

export default SwitchTimetableModal;
